export default "__VITE_ASSET__CaJYav0C__"